import { render, staticRenderFns } from "./History.vue?vue&type=template&id=cb910428&scoped=true&"
import script from "./History.vue?vue&type=script&lang=js&"
export * from "./History.vue?vue&type=script&lang=js&"
import style0 from "./History.vue?vue&type=style&index=0&id=cb910428&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb910428",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cb910428')) {
      api.createRecord('cb910428', component.options)
    } else {
      api.reload('cb910428', component.options)
    }
    module.hot.accept("./History.vue?vue&type=template&id=cb910428&scoped=true&", function () {
      api.rerender('cb910428', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/wheel/History.vue"
export default component.exports